<template>
  <div>
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-3" v-if="tieneGrupal">
        <div
          class="card shadow-sm h-100"
          style="
            border-radius: 10px;
            border: 1px solid #ccc;
            cursor: pointer;
            font-family: sans-serif;
          "
          @click="abrirGrupal({ grupal: true })"
        >
          <div
            style="
              background-color: darkgray;
              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
              padding: 8px;
              color: dark;
              text-align: center;
            "
          >
            <div style="font-weight: bold; font-size: 0.85rem;">Trabajo Grupal <span></span></div>
          </div>
          <div style="padding: 12px;">
            <div class="d-flex flex-wrap justify-content-center gap-2">
              <div class="estado-box mr-2 mb-2" :class="grupal.nuevo != null && grupal.nuevo != 0 ? 'bg-danger text-white' : 'gray-300'">
                {{ grupal.nuevo }}<template v-if="grupal.nuevo !== null"> - </template>Nuevo
              </div>
              <div class="estado-box mr-2 mb-2"
                :class="grupal.pendiente != null && grupal.pendiente != 0
                ? 'bg-success text-white' : 'gray-300'">
                <span style="font-size: 0.75rem;">
                  {{ grupal.pendiente }}
                  <template v-if="grupal.pendiente !== null"> - </template>
                </span>
                <span style="font-size: 0.75rem;">
                  <strong> Pendiente </strong>
                </span>
              </div>
              <div class="estado-box mr-2 mb-2"
                :class="grupal.trabajando != null && grupal.trabajando != 0
                ? 'bg-success text-white' : 'gray-300'">
                <span style="font-size: 0.75rem;">
                  {{ grupal.trabajando }}
                  <template v-if="grupal.trabajando !== null"> - </template>
                </span>
                <span style="font-size: 0.75rem;">
                  <strong> Trabajando </strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="paciente in listaPacientes"
        :key="paciente.orden_trabajo_id"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-3"
        @click="abrirModalAccion(paciente)"
      >
        <div
          class="card shadow-sm h-100"
          style="
            border-radius: 10px;
            border: 1px solid #ccc;
            cursor: pointer;
            font-family: sans-serif;
          "
        >
          <div
            :style="{
              backgroundColor: getColorEstado(paciente.estado_orden_id),
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              padding: '8px',
              color: getColorEstado(paciente.estado_orden_id) === '#28a745' ? 'white' : '#333'
            }"
          >
            <div style="font-weight: bold; font-size: 0.85rem;">
              N° O.T.: <span>{{ paciente.orden_trabajo_numero }}</span>
            </div>
            <div
              style="display: flex; justify-content: space-between;
                align-items: center; font-size: 0.75rem;"
              :style="{ color: getColorEstado(paciente.estado_orden_id) === '#28a745' ? 'white' : '#555' }"
            >
              <span>Fecha: {{ formatearFecha(paciente.fecha_origen) }}</span>
              <span style="font-size: 0.60rem;">{{ paciente.sucursal }}</span>
            </div>
          </div>
            <div style="padding: 12px;">
            <div style="font-weight: bold; font-size: 1rem; color: #000;">
              {{ paciente.nombre }}
            </div>
            <p style="color: #a39d9d">
              {{ paciente.servicio }}
            </p>
            <div style="display: flex; justify-content: space-between;
              align-items: center; margin-top: 8px;">
              <div style="font-size: 0.85rem; color: #333;">
                {{ paciente.parametro }}
              </div>
              <div style="font-size: 0.8rem; color: #f7941d; font-weight: 500;">
                {{ paciente.origen }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <theModalAccion ref="theModalAccion" />
  </div>
</template>

<script>
import theModalAccion from './theModalAccion.vue';

export default {
  name: 'OrdenItemDoctor',
  components: {
    theModalAccion,
  },
  props: {
    listaPacientes: {
      type: Array,
      required: true,
      default: () => [],
    },
    medico_id: {
      type: [Number, String],
      required: true,
    },
    grupal: {
      type: Object,
    },
  },
  data() {
    return {
      selectedCardId: null,
    };
  },
  computed: {
    tieneGrupal() {
      if (!this.grupal) return false;
      const { pendiente, nuevo, trabajando } = this.grupal;
      return Number(pendiente) > 0 || Number(nuevo) > 0 || Number(trabajando) > 0;
    },
  },
  methods: {
    goToDoctor(id) {
      this.$router.push({
        name: 'orden-trabajo-doctor',
        params: { id: this.encrypt(id) },
      });
    },
    encrypt(id) {
      return btoa(id);
    },
    abrirModalAccion(paciente) {
      this.selectedCardId = paciente.paciente_id;
      // Si el estado es 2 (Trabajando), navegar directamente sin abrir modal
      if (paciente.estado_orden_id === 2) {
        this.$router.push({
          name: 'orden-trabajo-doctor-edit',
          params: {
            id: this.encrypt(paciente.orden_trabajo_id),
          },
          query: {
            estado_orden_id: this.encrypt(2),
            medico_id: this.encrypt(this.medico_id),
            paciente_id: this.encrypt(paciente.paciente_id),
          },
        });
        return;
      }
      this.$refs.theModalAccion.show(paciente, this.medico_id);
    },
    getColorEstado(estado) {
      const estados = {
        1: '#ffe100', // Amarillo - Pendiente
        2: '#28a745', // Verde - Trabajando
      };
      return estados[estado] || '#ffe100'; // Amarillo por defecto
    },
    formatearFecha(fecha) {
      if (!fecha) return '';
      return fecha;
    },
    statusClass(code) {
      return this.estados[code] || 'bg-light text-dark';
    },
    abrirGrupal(options) {
      this.$router.push({
        name: 'orden-trabajo-grupal',
        params: { id: this.encrypt(this.medico_id) },
        query: {
          grupal: options.grupal ? 'true' : 'false',
        },
      });
    },
  },
};
</script>

<style scoped>
.bg-gray {
  background-color: rgba(232, 232, 232, 0.971);
}
.text-gray {
  color: #858189;
}
.border-radius {
  border-radius: 10px;
}
.line-height-1 {
  line-height: 1;
}

.card {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow: hidden;
  font-family: "Segoe UI", sans-serif;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
}

.card-header {
  padding: 8px 12px;
  color: white;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  position: relative;
}

.card-header.yellow {
  background-color: #fdd835;
  color: black;
}

.card-header.green {
  background-color: #388e3c;
}

.badge-rojo {
  background-color: #e53935;
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 8px;
}

.card-body {
  padding: 12px;
  background: white;
}

.nombre {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
}

.detalle {
  font-size: 14px;
  color: #444;
  margin-bottom: 6px;
}

.seccion {
  font-weight: bold;
  font-size: 14px;
  color: #f9a825;
}

.contador {
  font-weight: normal;
  color: #aaa;
  font-size: 13px;
}
.estado-box {
  min-width: 110px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #fff;
  text-align: center;
}
</style>
